import {createActionGroup, emptyProps} from '@ngrx/store';
import {Notification, NOTIFICATIONS_FEATURE_KEY} from '@store/notifications/notifications.types';

export const NotificationsActions = createActionGroup({
  source: NOTIFICATIONS_FEATURE_KEY,
  events: {
    'Load Notifications': emptyProps(),
    'Load Notifications Success': (notifications: Notification[]) => ({notifications}),
    'Load Notifications Failure': (error: unknown) => ({error}),

    'Mark Notification as Read': (notificationId: number) => ({notificationId}),
    'Mark Notification as Read Success': emptyProps(),
    'Mark Notification as Read Failure': (error: unknown) => ({error}),

    'Mark All Notifications as Read': emptyProps(),
    'Mark All Notifications as Read Success': emptyProps(),
    'Mark All Notifications as Read Failure': (error: unknown) => ({error}),
  }
});
